import type { DatasetImageLabelingJson } from "@/entities/dataset";
import type { Defect } from "@/entities/defect";
import type { BoundingBoxItem } from "@/ui/bounding-box";

export const getImageBoundingBoxes = (
  labeling?: DatasetImageLabelingJson,
  defects?: Defect[]
): BoundingBoxItem[] => {
  if (labeling?.type !== "boundingBox") {
    return [];
  }

  const elements = labeling.data ?? [];

  return elements.map(
    ({ BoundingBox, Name: slug }): BoundingBoxItem => ({
      slug,
      key: `dataset-image-bounding-box-${slug}`,
      label: defects?.find((defect) => defect.slug === slug)?.name ?? slug,
      left: BoundingBox.Left,
      top: BoundingBox.Top,
      width: BoundingBox.Width,
      height: BoundingBox.Height,
    })
  );
};
